import { useCallback } from 'react';
import useUrl from '../useUrl';
import { ChangeHandler, DateChangeHandler } from '../../../pages/ooh/types';

export const useOohUrlParams = () => {
  const { paramValue: dateParamValue, setParamValue: setDateParamValue } = useUrl<string>('Date');
  const { paramValue: agencyParamValue, setMultipleParams: setAgencyParamValue } = useUrl<string>('Agency');
  const { paramValue: routeParamValue, setParamValue: setRouteParamValue } = useUrl<string>('Route');

  const handleAgencyChanged = useCallback<ChangeHandler>(({ value }) => {
    setAgencyParamValue({
      Agency: value,
      Route: null,
    });
  }, [setAgencyParamValue]);

  const handleRouteChanged = useCallback<ChangeHandler>(({ value }) => {
    setRouteParamValue(value);
  }, [setRouteParamValue]);

  const handleDateChanged = useCallback<DateChangeHandler>((e) => {
    const { value } = e.target;
    setDateParamValue(value);
  }, [setDateParamValue]);

  return {
    dateParamValue,
    agencyParamValue,
    routeParamValue,
    handleAgencyChanged,
    handleRouteChanged,
    handleDateChanged,
  };
};